import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { Spinner } from "@/components/ui/spinner";
import { useAuth } from "@/contexts/AuthContext";
import { resolveLandingRoute } from "@/lib/resolve-landing-route";

export const Route = createFileRoute("/_auth")({
  component: AuthLayout,
});

function AuthLayout() {
  const { isLoading, isAuthenticated, requiresPasswordChange, userRoleType } =
    useAuth();
  const navigate = useNavigate();

  // Redirect authenticated users to appropriate page
  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      // If user needs to set password, redirect there instead of dashboard
      if (requiresPasswordChange) {
        navigate({ to: "/set-password", replace: true });
      } else {
        navigate({ to: resolveLandingRoute(userRoleType), replace: true });
      }
    }
  }, [
    isLoading,
    isAuthenticated,
    requiresPasswordChange,
    userRoleType,
    navigate,
  ]);

  // Show loading while checking auth state
  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner className="h-8 w-8 text-primary" />
      </div>
    );
  }

  // Don't render auth pages if authenticated (redirect is happening)
  if (isAuthenticated) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner className="h-8 w-8 text-primary" />
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <Outlet />
    </div>
  );
}
